export default __webpack_public_path__ + "static/media/LabCorp-Button.a87dd312.png";